import React, {Component, Fragment} from 'react';
import AddActionButton from "../common/AddActionButton";
import './SubDepartments.scss';
import Modal from "../../../shared/ui/Modal";
import CustomForm from "../../../shared/components/form/CustomForm";
import {subDepartmentsConfig} from "../../../shared/components/form/SubDepartmentsConfig";
import {connect} from "react-redux";
import subDepartmentsActionCreators from "../../store/sub-departments/action-creators";

class SubDepartments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddModalOpen: false
    }
  }

  toggleIsAddingSubDepartment() {
    this.setState({
      isAddModalOpen: !this.state.isAddModalOpen
    })
  }

  onAddSubDepartment() {
    this.setState({
      isAddModalOpen: true
    })
  }

  addSubDepartment(data) {
    this.props.addSubDepartment({
      name: data.name,
      phones: [{
        countryCode: "1",
        isDefault: true,
        label: 'default',
        phoneNumber: data.phoneNumber
      }]
    }).then(() => {
      this.toggleIsAddingSubDepartment();
    })
  }


  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Divisions</h4>
          <AddActionButton label="Division" onAdd={() => this.onAddSubDepartment()} />
        </div>
        <div className="app-content sub-departments">
          <div className="card">
            { this.props.subDepartments.length
              ? this.props.subDepartments.map(subDepartment => (
                  <div key={subDepartment.guid} className="sub-department">{subDepartment.name}</div>
                ))
              : <div className="sub-department">No divisions added</div>
            }
          </div>
        </div>
        <Modal
          isOpen={this.state.isAddModalOpen}
          title="Add new Task Group"
          onClose={() => this.toggleIsAddingSubDepartment()}>
          <CustomForm
            config={subDepartmentsConfig}
            onSubmit={(data) => this.addSubDepartment(data)}
            isLoading={this.props.isLoading.includes('addSubDepartment')}/>
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.subDepartments.isLoading,
    subDepartments: state.subDepartments.list
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addSubDepartment: (data) =>
      dispatch(subDepartmentsActionCreators.createSubDepartment(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SubDepartments);